import type { IBrandConfig } from './types';

const PSMS_BRAND_CONFIG: IBrandConfig = {
  privacyPolicy: {
    kind: 'cms',
    path: 'policy/privacy-medical-shield-policy.md',
  },
  termsOfService: {
    kind: 'cms',
    path: 'policy/tou/privacy-medical-shield-terms.md',
  },
  websiteTermsOfUse: { kind: 'none' },
  refundPolicy: { kind: 'none' },
  idTheftProtection: { kind: 'none' },
  licensor: 'cyex',
  enrollmentFaqRequiredInfo: 'contactOnly',
  vaultProject: 'privacy_medical_shield',
  adaChat: true,
  accountDetails: true,
  personalInformation: false,
  secureUpload: true,
  security: true,
  missingPII: true,
  finishSetup: true,
  defaultBillingCategoryKey: 'privacy_breach',
  copyRightEntity: 'CyEx, LLC',
  hasCustomerServiceSupport: true,
  ssoRedirectURL: null,
  carouselBanners: true,
  dwEmailVerification: {
    adaChat: true,
    signInButton: true,
    supportAt: null,
    availability:
      'Representatives are available Monday – Friday, 8AM-11PM ET and Saturday, 9AM-6PM ET.',
  },
  supportPage: {
    pageTitle: {
      active: true,
      title: 'More ways to reach us',
    },
    faq: {
      active: true,
    },
    pages: [],
    call: {
      availability: (
        <>
          Monday – Friday, 8AM-11PM ET <br /> Saturday, 9AM-6PM ET
        </>
      ),
    },
    mail: {
      active: true,
      address: 'PO Box 52330 Boston, MA 02205',
      customerSupport: false,
    },
    email: {
      active: true,
      customerSupport: true,
    },
  },
};

export default PSMS_BRAND_CONFIG;
